import { __ } from '@wordpress/i18n';

export const generalStyleTabs = [
	{ name: 'general', title: __('General', 'textdomain') },
	{ name: 'style', title: __('Style', 'textdomain') }
];

export const themesOption = [
	{ label: 'Default', value: 'theme1' },
	{ label: 'Style 2', value: 'theme2' },
	{ label: 'Style 3', value: 'theme3' }
]
export const contentAlignment = [
	{ label: 'Left', value: 'left' },
	{ label: 'Center', value: 'center' },
	{ label: 'Right', value: 'right' }
]


export const toolTipPresets = [
	{
		label: "Default",
		value: "theme1",
		img: "https://templates.bplugins.com/wp-content/uploads/2025/04/image-3.png",
		height: "auto",
		width: "160px",
		},
		{
		label: "Style One",
		value: "theme2",
		img: "https://templates.bplugins.com/wp-content/uploads/2025/04/image-2.png",
		height: "auto",
		width: "160px",
		},
		{
		label: "Style Two",
		value: "theme3",
		img: "https://templates.bplugins.com/wp-content/uploads/2025/04/image-4.png",
		height: "auto",
		width: "160px",
	},
  ];